<template>
  <div>Activity</div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>
